import { Controller } from "@hotwired/stimulus"

// Примеры живой открытки: движение без веса страницы.
// Ролики висят с preload="none" и постером-первым кадром, пока не попадут в
// зону видимости; там подключается автоплей без звука, за экраном — пауза.
// JS-first: без JS и при reduced-motion остаются нативные controls, то есть
// ролик всё равно можно посмотреть (см. reveal_controller — тот же приём).
export default class extends Controller {
  static targets = ["video"]

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.videoTargets.forEach((video) => video.removeAttribute("controls"))

    this.observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => this.toggle(entry)),
      { threshold: 0.25 }
    )
    this.videoTargets.forEach((video) => this.observer.observe(video))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  toggle(entry) {
    const video = entry.target
    if (!entry.isIntersecting) {
      video.pause()
      return
    }
    // Браузер вправе отказать в автоплее (политика экономии трафика) — тогда
    // возвращаем controls, чтобы ролик остался смотрибельным.
    video.play().catch(() => video.setAttribute("controls", ""))
  }
}
